export default "__VITE_ASSET__817635c2__"